import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-[#cbb26a]/20 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo et Description */}
          <div>
            {/* === LOGO IMAGE AU LIEU DU TEXTE === */}
            <img
              src="/images/logo.png"
              alt="LabradorLOF – génétique d'excellence"
              className="h-28 md:h-32 w-auto mb-4"
            />

            <p className="text-white/70 text-sm mb-4">
              Service professionnel de saillie pour votre Labrador. Mâle chocolat LOF en excellente santé.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61584777749466"
target="_blank"
rel="noopener noreferrer"
                className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/labradorlof_tarzan/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
    aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Navigation rapide */}
          <div>
            <h3 className="text-[#cbb26a] font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/reproducteur"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Mâle Reproducteur
                </Link>
              </li>
              <li>
                <Link
                  to="/conditions"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Conditions de Saillie
                </Link>
              </li>
              <li>
                <Link
                  to="/galerie"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Galerie Photos
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-[#cbb26a] font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/tarifs"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Tarifs
                </Link>
              </li>
              <li>
                <Link
                  to="/disponibilites"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Disponibilités
                </Link>
              </li>
              <li>
                <Link
                  to="/temoignages"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Témoignages
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#cbb26a] font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="flex items-center space-x-2 text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  <Phone size={16} />
                  <span>{contactInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center space-x-2 text-white/70 hover:text-[#cbb26a] transition-colors duration-300"
                >
                  <Mail size={16} />
                  <span>{contactInfo.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-[#cbb26a]/20 text-center">
          <p className="text-white/60 text-sm">
            © {currentYear} Labradordesdombes.com - Tous droits réservés – Sainte-Olive (01330)
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
